export const repair_use_credits_sheet = {
  sheet_title: "Use repair credits",
  close_aria: "Close",
  field_part: "Part to repair",
  field_repair_cost: "Repair cost (approx.)",
  field_shop: "Repair shop name",
  field_work_order: "Work Order",
  field_notes: "Notes",
  submit: "Submit request",
} as const;
